"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var SalesDashboardExcelFileDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SalesDashboardExcelFileDTO, _DomainObject_1$Domai);

  /**
   * Creates new instance of SalesDashboardExcelFile.
   * @param id ID of the SalesDashboardExcelFile
   * @param fileId ID of the file
   * @param note note
   */
  function SalesDashboardExcelFileDTO(id, fileId, filename, uploadDate, note) {
    var _this;

    _classCallCheck(this, SalesDashboardExcelFileDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardExcelFileDTO).call(this));
    _this.id = id;
    _this.fileId = fileId;
    _this.filename = filename;
    _this.uploadDate = uploadDate;
    _this.note = note;
    return _this;
  }

  return SalesDashboardExcelFileDTO;
}(DomainObject_1.DomainObject);

exports.SalesDashboardExcelFileDTO = SalesDashboardExcelFileDTO;

SalesDashboardExcelFileDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SalesDashboardExcelFileDTO.name);
  return {
    id: builder.id('id'),
    fileId: builder.str('fileId'),
    filename: builder.str('filename'),
    uploadDate: builder.date('uploadDate', DateParser_1.DateParser.ISO_PATTERN),
    note: builder.opt(builder.str('note'))
  };
}();